/**
 * Cross-platform sort indicator for table column headers.
 * Unicode ↕/↑/↓ render differently on iOS vs Android — use this SVG instead
 * so both platforms match the thin double-arrow look shown on Android.
 *
 * @param {'up'|'down'|null} direction
 *   null  → unsorted (↕)
 *   'up'  → ascending indicator (↑)
 *   'down'→ descending indicator (↓)
 */
export function SortIcon({ direction = null, className = '' }) {
  if (direction === 'up') {
    return (
      <svg
        className={className}
        width="10"
        height="12"
        viewBox="0 0 10 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M5 1.5L5 10.5M5 1.5L2 4.5M5 1.5L8 4.5"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (direction === 'down') {
    return (
      <svg
        className={className}
        width="10"
        height="12"
        viewBox="0 0 10 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M5 10.5L5 1.5M5 10.5L2 7.5M5 10.5L8 7.5"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  // Unsorted — thin double-headed arrow matching Android system ↕ look
  return (
    <svg
      className={className}
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M5 1.25L5 12.75M5 1.25L2.25 4M5 1.25L7.75 4M5 12.75L2.25 10M5 12.75L7.75 10"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Maps existing table sortConfig → SortIcon direction (preserves prior ↑/↓ mapping). */
export function sortIconDirection(sortConfig, columnKey) {
  if (!sortConfig || sortConfig.key !== columnKey) return null;
  // Existing tables used: asc → '↓', desc → '↑'
  return sortConfig.direction === 'asc' ? 'down' : 'up';
}
